import React, { useState } from 'react'

export default function StatsComponent({ Data, showMoreButton = false }) {
    const [showMore, setShowMore] = useState(false);

    const formatIndianNumber = (value) => {
        if (!value) return value;

        const number = Number(value?.replace(/[^0-9]/g, ""));
        return number.toLocaleString("en-IN");
    };

    const handleShowMore = (type) => {
        setShowMore(type)
    }


    return (
        <>
            {
                !showMore ?

                    <div className='statsOption' style={{ marginTop: '30px' }}>

                        <div className="cusombox">

                            {
                                Object.keys(Data)?.length > 0 ? Object.entries(Data)?.map(([key, val], id) => {
                                    console.log("val",val)
                                    return (
                                        <div style={{ borderRight: id + 1 == Object.keys(Data)?.length ? "none" : "1px solid rgba(0, 0, 0, 0.12)", padding: '5px 10px', width: `calc(100% / ${Object.keys(Data)?.length})` }}>
                                            <h5>{val}</h5>
                                            <h6>{key}</h6>
                                            {
                                               ( key == "Total API Cost" || key == 'Total API Cost (Disbursed Loans)') && !(Number(val?.replace(/[^0-9.-]+/g, "")) > 0) ?
                                                <h6 style={{color:'#949393'}}><i>(API Cost Not Configured Yet!)</i></h6>
                                            :""}
                                        </div>
                                    )
                                })
                                    : ""}
                        </div>
                        {
                            showMoreButton ?
                                <div style={{ textAlign: 'center' }}>
                                    <h5 style={{ color: "rgba(3, 88, 101, 1)", background: "rgba(102, 172, 175, 0.36)", padding: "5px 10px", margin: '5px 0 0 0', borderRadius: '8px', display: 'inline', textDecoration: 'underline', cursor: 'pointer', fontSize: '12px' }}
                                        onClick={() => handleShowMore(!showMore)}
                                    >{!showMore ? "View all Quick Insights" : "View Less"}</h5>
                                </div>
                                : ""}
                    </div>
                    : ""}


            {
                showMore ?
                    <div className='customShowStatsOption'>
                        <div className='row'>
                            <div className="col-sm-4 col-xs-12">
                                <div className='customcard'>
                                    <h4>Overall Business Health</h4>

                                    <div className='customDatarow'>
                                        <h5 className='customDataLeft'>Total Loans Applied</h5>
                                        <h5 className='customDataRight'>10,000</h5>
                                    </div>
                                    <div className='customDatarow'>
                                        <h5 className='customDataLeft'>Total Loans Approved</h5>
                                        <h5 className='customDataRight'>10,000</h5>
                                    </div>
                                    <div className='customDatarow'>
                                        <h5 className='customDataLeft'>Total Loans Disbursed</h5>
                                        <h5 className='customDataRight'>10,000</h5>
                                    </div>
                                    <div className='customDatarow'>
                                        <h5 className='customDataLeft'>Disbursement Rate (%)</h5>
                                        <h5 className='customDataRight'>10,000</h5>
                                    </div>
                                    <div className='customDatarow'>
                                        <h5 className='customDataLeft'>Approval Rate (%)</h5>
                                        <h5 className='customDataRight'>10,000</h5>
                                    </div>
                                </div>
                                <div className='customcard'>
                                    <h4>API Cost Economics</h4>

                                    <div className='customDatarow'>
                                        <h5 className='customDataLeft'>Total API Cost</h5>
                                        <h5 className='customDataRight'>10,000</h5>
                                    </div>
                                    <div className='customDatarow'>
                                        <h5 className='customDataLeft'>API Cost per Application</h5>
                                        <h5 className='customDataRight'>10,000</h5>
                                    </div>
                                    <div className='customDatarow'>
                                        <h5 className='customDataLeft'>API Cost per Approved Loan</h5>
                                        <h5 className='customDataRight'>10,000</h5>
                                    </div>
                                    <div className='customDatarow'>
                                        <h5 className='customDataLeft'>API Cost per Disbursed Loan</h5>
                                        <h5 className='customDataRight'>10,000</h5>
                                    </div>
                                    <div className='customDatarow'>
                                        <h5 className='customDataLeft'>API Cost % of Disbursed Amount</h5>
                                        <h5 className='customDataRight'>10,000</h5>
                                    </div>
                                </div>
                                <div className='customcard'>
                                    <h4>Scalability Indicators (MoM)</h4>

                                    <div className='customDatarow'>
                                        <h5 className='customDataLeft'>API Cost Growth Rate</h5>
                                        <h5 className='customDataRight'>10,000</h5>
                                    </div>
                                    <div className='customDatarow'>
                                        <h5 className='customDataLeft'>Loan Growth Rate</h5>
                                        <h5 className='customDataRight'>10,000</h5>
                                    </div>
                                    <div className='customDatarow'>
                                        <h5 className='customDataLeft'>Cost vs Growth Ratio</h5>
                                        <h5 className='customDataRight'>10,000</h5>
                                    </div>

                                </div>
                            </div>
                            <div className="col-sm-4 col-xs-12">
                                <div className='customcard'>
                                    <h4>Funnel Efficiency KPIs</h4>

                                    <div className='customDatarow'>
                                        <h5 className='customDataLeft'>Application Completion Rate</h5>
                                        <h5 className='customDataRight'>10,000</h5>
                                    </div>
                                    <div className='customDatarow'>
                                        <h5 className='customDataLeft'>Drop-off Rate (Pre-Approval)</h5>
                                        <h5 className='customDataRight'>10,000</h5>
                                    </div>
                                    <div className='customDatarow'>
                                        <h5 className='customDataLeft'>Drop-off Rate (Post-Approval)</h5>
                                        <h5 className='customDataRight'>10,000</h5>
                                    </div>
                                    <div className='customDatarow'>
                                        <h5 className='customDataLeft'>Top Drop-off Stage</h5>
                                        <h5 className='customDataRight'>Bank Statement Upload</h5>
                                    </div>

                                </div>
                                <div className='customcard'>
                                    <h4>Vendor Cost & ROI KPIs</h4>

                                    <div className='customDatarow'>
                                        <h5 className='customDataLeft'>Wasted API Cost</h5>
                                        <h5 className='customDataRight'>10,000</h5>
                                    </div>
                                    <div className='customDatarow'>
                                        <h5 className='customDataLeft'>Wasted Cost %</h5>
                                        <h5 className='customDataRight'>10,000</h5>
                                    </div>
                                    <div className='customDatarow'>
                                        <h5 className='customDataLeft'>Cost Lost to Drop-offs</h5>
                                        <h5 className='customDataRight'>10,000</h5>
                                    </div>
                                    <div className='customDatarow'>
                                        <h5 className='customDataLeft'>Cost Lost to Rejections</h5>
                                        <h5 className='customDataRight'>₹14,000</h5>
                                    </div>

                                </div>
                                <div className='customcard'>
                                    <h4>RISK & CONTROL KPIs</h4>

                                    <div className='customDatarow'>
                                        <h5 className='customDataLeft'>High-Cost API Exposure</h5>
                                        <h5 className='customDataRight'>10,000</h5>
                                    </div>
                                    <div className='customDatarow'>
                                        <h5 className='customDataLeft'>Critical API Failure Rate</h5>
                                        <h5 className='customDataRight'>10,000</h5>
                                    </div>
                                    <div className='customDatarow'>
                                        <h5 className='customDataLeft'>Fraud API Cost Ratio</h5>
                                        <h5 className='customDataRight'>10,000</h5>
                                    </div>
                                    <div className='customDatarow'>
                                        <h5 className='customDataLeft'>Disbursement Failure Cost</h5>
                                        <h5 className='customDataRight'>₹14,000</h5>
                                    </div>

                                </div>
                            </div>
                            <div className="col-sm-4 col-xs-12">
                                <div className='customcard'>
                                    <h4>Time - To - Money KPIs</h4>

                                    <div className='customDatarow'>
                                        <h5 className='customDataLeft'>Avg Time to Approval</h5>
                                        <h5 className='customDataRight'>10,000</h5>
                                    </div>
                                    <div className='customDatarow'>
                                        <h5 className='customDataLeft'>Avg Time to Disbursement</h5>
                                        <h5 className='customDataRight'>10,000</h5>
                                    </div>
                                    <div className='customDatarow'>
                                        <h5 className='customDataLeft'>End-to-End TAT</h5>
                                        <h5 className='customDataRight'>10,000</h5>
                                    </div>


                                </div>
                                <div className='customcard'>
                                    <h4>Unit Economics</h4>

                                    <div className='customDatarow'>
                                        <h5 className='customDataLeft'>Cost to Acquire 1 Disbursed Loan</h5>
                                        <h5 className='customDataRight'>10,000</h5>
                                    </div>
                                    <div className='customDatarow'>
                                        <h5 className='customDataLeft'>Net Revenue per Loan</h5>
                                        <h5 className='customDataRight'>10,000</h5>
                                    </div>
                                    <div className='customDatarow'>
                                        <h5 className='customDataLeft'>Break-even Loan Size</h5>
                                        <h5 className='customDataRight'>10,000</h5>
                                    </div>


                                </div>
                                <div className='customcard'>
                                    <h4>Wasted Cost KPIs</h4>

                                    <div className='customDatarow' style={{ flexDirection: 'column',alignItems:"start" }}>
                                        <h5 className='customDataRight'>Cost per API Vendor</h5>
                                        <h5 className='customDataLeft'>CRIF: ₹35L   CIBIL: ₹28L    BankStmt: ₹22L    eSign: ₹20L    eNACH: ₹15L</h5>
                                    </div>
                                    <div className='customDatarow' style={{ flexDirection: 'column',alignItems:"start" }}>
                                        <h5 className='customDataRight'>Approval Impact per Vendor</h5>
                                        <h5 className='customDataLeft'>CRIF: 45%   CIBIL: 30%    BankStmt: 15%    Other: 10%</h5>
                                    </div>
                                    <div className='customDatarow' style={{ flexDirection: 'column',alignItems:"start" }}>
                                        <h5 className='customDataRight'>Failure Cost per Vendor</h5>
                                        <h5 className='customDataLeft'>BankStmt: ₹18L    eSign: ₹6L   </h5>
                                    </div>
                                    <div className='customDatarow' style={{ flexDirection: 'column',alignItems:"start" }}>
                                        <h5 className='customDataRight'>Vendor SLA Compliance (%)</h5>
                                        <h5 className='customDataLeft'>CRIF: 99%   CIBIL: 98%    BankStmt: 92%    esign: ₹15L</h5>
                                    </div>



                                </div>
                            </div>
                        </div>
                        <div style={{ textAlign: 'center' }}>
                            <h5 style={{ color: "rgba(3, 88, 101, 1)", background: "rgba(102, 172, 175, 0.36)", padding: "5px 10px", margin: '5px 0 0 0', borderRadius: '8px', display: 'inline', textDecoration: 'underline', cursor: 'pointer', fontSize: '12px' }}
                                onClick={() => handleShowMore(!showMore)}
                            >{!showMore ? "View all Quick Insights" : "View Less"}</h5>
                        </div>
                    </div>
                    : ""}
        </>
    )
}
